export const firstRowHeight = 82.5;
export const secondRowHeight = 24.75;

// Formatos
export const numberFormat = "#,##0.00;[Red]-#,##0.00";
export const monetaryFormat = '"R$ "#,##0.00;[Red]-"R$ "#,##0.00';
export const percentageFormat = '#,##0.00"%";[Red]-#,##0.00"%"';

export const alphabet = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
];



// WEBPACK FOOTER //
// ./src/modules/costPlan/assets/excelReports/constants.ts